import React from 'react';

import { VideoCollectionRow } from '@/components/VideoCollectionRow';
import { LinkFrom } from '@/config/constants';
import { GetDashboardQuery } from '@/graphql';
import { classNames } from '@/helpers/classNames';

import { LibraryTabProps } from '../../Library';
import libraryStyles from '../../Library.module.scss';

export const PickedForYou: React.FC<LibraryTabProps> = ({
	videoCollections,
}) => {
	return (
		<>
			{/* <div
				className={classNames([
					libraryStyles['title'],
					libraryStyles['with-margin'],
				])}
			>
				Browse all
			</div> */}
			{(videoCollections || []).map((vc) => (
				<VideoCollectionRow
					key={`picked-for-you-video-collection-${vc.id}`}
					className={libraryStyles['video-collection']}
					videoCollection={vc}
					linkFrom={LinkFrom.library}
				/>
			))}
		</>
	);
};
